module.exports = __webpack_public_path__ + "img/PRESUPUESTO.d7338265.jpg";